import axios from 'axios'
import { useParams } from 'react-router-dom';
import { FileActionFunction, FileItemType } from '../../types/communication/communicationDataType';
import { FileList, FileListTitle } from '../styled/File.style';
import { Vspace } from '../styled/Separators.style';
import FileItemCmp from './FileItemCmp';

interface FileListCmpProps {
    files: FileItemType[];
    onFileRemoved: FileActionFunction;
    className?: string;
    previewCustomClass?: string
    children?: JSX.Element
    hasResizer?: boolean
    isCameraFileImage?: boolean
    titleImageDetail?: string
    addButtonInLastPlace?: boolean
    companyName?: string;
    alreadySentDocIds?: string[];
    deleteLabelPresent?: boolean;
    isInMultiCard?: boolean;
}

const FileListCmp = (props: FileListCmpProps) => {
    const { token } = useParams();
    let { files, onFileRemoved, className, children,
        hasResizer, previewCustomClass, isCameraFileImage,
        titleImageDetail, addButtonInLastPlace, companyName,
        alreadySentDocIds, deleteLabelPresent, isInMultiCard } = props

    const isInMultiCardClass = isInMultiCard ? 'is-in-multi-card' : ''

    const isLinear = companyName === "LINEAR";
    const hasFiles = files?.length > 0;

    const deleteFileHandler = (_file?: FileItemType) => {
        if (!_file) {
            return _file
        }
        const requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/attachment/${_file._id}`;
        axios.delete(requestURL)
            .then(() => onFileRemoved(_file))
            .catch((err: any) => console.error(err));
    };

    if (isLinear && files?.length === 0) {
        className = className + " none"
    }

    return (
        <>
            {hasFiles && <FileListTitle className={companyName}>Le tue foto</FileListTitle>}
            {!isLinear && <Vspace />}

            <FileList className={`${className} ${isInMultiCardClass}`}>
                {!isLinear && !addButtonInLastPlace && children}
                {files?.map((f, ind) => (
                    <FileItemCmp
                        key={`${f.name}_${ind}`}
                        fullPageCanDelete={true}
                        file={f}
                        deleteFile={(f?: FileItemType) => deleteFileHandler(f)}
                        companyName={companyName}
                        alreadySentDocIds={alreadySentDocIds}
                        hasResizer={hasResizer}
                        previewCustomClass={previewCustomClass}
                        isCameraFileImage={isCameraFileImage}
                        titleImageDetail={titleImageDetail}
                        deleteLabelPresent={deleteLabelPresent}
                    />
                ))}
                {!isLinear && addButtonInLastPlace && children}
            </FileList>
            {isLinear && children}
        </>
    );
};

export default FileListCmp;
